import React from 'react';
import {css} from '@emotion/core';
import {cx} from 'emotion';

export const Flex = () => <div>Namespace Only. Do Not Use</div>;

type FlexProps = {
  className?: string;
  fill?: boolean;
  flex?: number;
};

type RowProps = FlexProps & {
  align?: 'top' | 'center' | 'bottom';
  vAlign?: 'top' | 'center' | 'bottom';
  justifyContent?:
    | 'space-between'
    | 'space-around'
    | 'space-evenly'
    | 'flex-start'
    | 'flex-end'
    | 'justify-center';
};

type ColProps = FlexProps & {
  align?: 'left' | 'center' | 'right';
  justifyContent?:
    | 'space-between'
    | 'space-around'
    | 'space-evenly'
    | 'flex-start'
    | 'flex-end'
    | 'justify-center';
};

const Row: React.FC<RowProps> = (props) => {
  const className = cx('row', props.className, {
    [props.align as string]: !!props.align,
    [props.vAlign as string]: !!props.vAlign,
    [props.justifyContent as string]: !!props.justifyContent,
    fill: !!props.fill,
  });
  const {children} = props;

  return (
    <div css={styles} className={className} style={{flex: props.flex ?? ''}}>
      {children}
    </div>
  );
};

const Col: React.FC<ColProps> = (props) => {
  const className = cx('column', props.className, {
    [props.align as string]: !!props.align,
    [props.justifyContent as string]: !!props.justifyContent,
    fill: !!props.fill,
  });
  const {children} = props;

  return (
    <div css={styles} className={className} style={{flex: props.flex ?? ''}}>
      {children}
    </div>
  );
};

const Fill: React.FC<{className?: string}> = ({children, className}) => (
  <div className={cx('fill', className)}>{children}</div>
);
const Box: React.FC<{className?: string}> = ({children, className}) => (
  <div className={cx('box', className)}>{children}</div>
);

Flex.Row = Row;
Flex.Col = Col;
Flex.Fill = Fill;
Flex.Box = Box;

const styles = css`
  &.row {
    display: flex;
    flex-direction: row;

    @media only screen and (max-width: 767px) {
      display: block;

      > * {
        margin-bottom: 1rem;
      }
    }

    &.top {
      align-items: flex-start;
    }

    &.center {
      align-items: center;
    }

    &.bottom {
      align-items: flex-end;
    }

    &.space-between {
      justify-content: space-between;
    }

    &.space-around {
      justify-content: space-around;
    }

    &.space-evenly {
      justify-content: space-evenly;
    }

    &.flex-start {
      justify-content: flex-start;
    }

    &.flex-end {
      justify-content: flex-end;
    }

    &.justify-center {
      justify-content: center;
    }
  }

  &.column {
    display: flex;
    flex-direction: column;

    &.center {
      align-items: center;
    }

    &.bottom {
      align-items: flex-end;
    }

    &.space-between {
      justify-content: space-between;
    }

    &.space-around {
      justify-content: space-around;
    }

    &.space-evenly {
      justify-content: space-evenly;
    }

    &.flex-start {
      justify-content: flex-start;
    }

    &.flex-end {
      justify-content: flex-end;
    }

    &.justify-center {
      justify-content: center;
    }
  }

  .fill {
    flex: 1 1 0%;
  }
`;
